import { APP_SIDEBAR } from './modules/appSidebar'
import { GUIDE_ACTIONS } from './modules/guide'

export const STORE_CONST = {
  APP_SIDEBAR,
  GUIDE_ACTIONS
}
